import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import { Button, Spin, Tabs } from 'antd';
import Panel from '../../../../components/Panel';
import channelConstructor from '../../../../services/Andes_v2/channel/channelConstructor';
import { getPanelMaxHeight, getPanelMaxWidth, getPanelWidth } from '../../../../services/helper/panelSizeHelper';
import { isPreLayout } from '../../../../services/Andes_v2';
import ExtractionOptions from '../../Channel/ExtractionOptionPanel/extractionOptions';
import { getHybridErrorMsg } from '../../../../services/Andes_v2/channel';
import './index.css';

class ExtractionOptionPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeKey: '',
      hybridErrorMsg: "",
      tabs: [],
      contentLoading: true
    }
    this.dialogRoot = document.getElementById('root');
  }

  componentDidMount() {
    const { endToEndId, endToEndSettingChannelId } = this.props;
    const channels = channelConstructor.getChannelsByEndToEndId(endToEndId);
    const tabs = channels.map(channel => {
      return {
        key: channel.id,
        label: channel.pcbName,
        disabled: isPreLayout(channel.designId)
      }
    })
    const tab = tabs.find(tab => tab.key === endToEndSettingChannelId) || tabs.find(tab => !tab.disabled) || {};
    this.setState({ tabs, activeKey: tab.key || "", contentLoading: !endToEndSettingChannelId }, () => {
      if (tab.key && !endToEndSettingChannelId) {
        this.props._getChannelContent(tab.key);
        this.props._updateEndToEndSettingId(tab.key)
      }
    });
    window.addEventListener('resize', this.resize);
    this.resize();
  }

  componentDidUpdate(prevProps) {
    //switch channel , close panel
    const { channelId, channelLoading } = this.props;
    if (channelId !== prevProps.channelId) {
      this.props.closePanel();
    }

    if (!channelLoading && channelLoading !== prevProps.channelLoading) {
      this.setState({ contentLoading: false })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  resize = () => {
    const offset = this.dialogRoot.getBoundingClientRect();
    this.setState({
      maxHeight: getPanelMaxHeight(offset, 450),
      maxWidth: getPanelMaxWidth(offset, 910)
    })
  }

  closePanel = () => {
    const { activeKey } = this.state;
    this.props._updateEndToEndSettingId(null);
    if (!activeKey) {
      this.props.closePanel();
      return;
    };
    this.saveSetup("close");
  }

  saveSetup = (saveType, nextChannelId, simulationEndToEndId) => {
    if (!this.optionsRef) { return };
    let _info = this.optionsRef.state;
    let extraction = _info && _info.extractionConfig ? _info.extractionConfig : {};
    if (!_info || !_info.extractionConfig) {
      _info = this.optionsRef.props;
      extraction = _info && _info.extraction ? _info.extraction : {};
    }
    const hybridRegions = this.optionsRef.props.hybridRegions;
    const hybridErrorMsg = this.getHybridRegionsHFSSError(hybridRegions, null, extraction)
    if (hybridErrorMsg) { return true }
    this.optionsRef.closeModal(saveType, nextChannelId, simulationEndToEndId);
    if (saveType === "close") {
      this.props.closePanel();
      this.props._clearPCBChannelInfo();
    }
    return false;
  }

  getHybridRegionsHFSSError = (hybridRegions, time, extraction) => {
    const hybridErrorMsg = getHybridErrorMsg(hybridRegions, extraction);
    this.setState({
      hybridErrorMsg
    })
    if (time) {
      setTimeout(() => {
        this.setState({
          hybridErrorMsg: ''
        })
      }, 4000);
    }
    return hybridErrorMsg
  }

  clearHybridErrorMsg = () => {
    this.setState({
      hybridErrorMsg: ''
    })
  }

  tabContent = () => {
    const { activeKey, hybridErrorMsg, contentLoading } = this.state;
    return activeKey ? <Spin spinning={contentLoading}>
      {!contentLoading ? <ExtractionOptions
        onRef={(ref) => this.optionsRef = ref}
        hybridErrorMsg={hybridErrorMsg}
        getHybridRegionsHFSSError={this.getHybridRegionsHFSSError}
        clearHybridErrorMsg={this.clearHybridErrorMsg}
        // setStackupData={this.setStackupData}
        isEndToEndChildren={true}
        contentClassName="andes-v2-end-to-end-extraction-options-content"
        type="end-to-end-extraction"
      /> : <div className='andes-v2-end-to-end-extraction-options-content'></div>}
    </Spin> : <div className='andes-v2-end-to-end-extraction-options-content'></div>;
  }

  simulateClick = () => {
    const { endToEndId } = this.props;
    const { activeKey } = this.state;
    if (!activeKey) {
      this.props._startEndToEndSimulation();
    } else {
      const isError = this.saveSetup("modeling", null, endToEndId);
      if (isError) { return };
    }
    this.props._updateEndToEndSettingId(null);
    this.props._clearPCBChannelInfo();
    this.props.closePanel();
  }

  footerRender = () => {
    return <div className="andes-v2-panel-footer-center-button">
      <Button type="primary" size="small" onClick={() => this.simulateClick()}>
        Extract Model
      </Button>
    </div>
  }

  onChange = (activeKey) => {
    const { channelLoading } = this.props;
    if (channelLoading) { return };
    // save current tab info
    const isError = this.saveSetup("save", activeKey);
    if (isError) { return };
    this.setState({ activeKey, contentLoading: true });
  }

  render() {
    const { tabs, activeKey, maxHeight, maxWidth } = this.state;
    const content = <Panel
      className='andes_v2-channel-extraction-panel panel-x-scroll-hidden'
      title={<div className='andes_v2-channel-extraction-option-title'>Extraction Options</div>}
      onCancel={() => this.closePanel()}
      zIndex={2000}
      position='panel-center'
      draggable
      minHeight={200}
      minWidth={470}
      width={getPanelWidth(maxWidth, { defaultWidth: 910 })}
      maxHeight={maxHeight}
      overflow="auto"
      footer={this.footerRender()}
    >
      <div className='andes-v2-end-to-end-extraction-content'>
        <Tabs
          activeKey={activeKey}
          items={tabs}
          onChange={this.onChange}
        />
        {this.tabContent()}
      </div>
    </Panel>

    return createPortal(content, this.dialogRoot)
  }
}

export default ExtractionOptionPanel;